import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {withStyles} from "@material-ui/core";
import BBIconAnalysisNetwork from "../../../assets/bbCustomIcons/BBIconAnalysisNetwork";
import Tooltip from "@material-ui/core/Tooltip";
import AttackInspector from "../inspectors/AttackInspector";
import BBIconQuickViewMagnifying from "../../../assets/bbCustomIcons/BBIconQuickViewMagnifying";

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const FormDialog = (props) => {
    const [open, setOpen] = React.useState(false);

    const {
        isTimelineButtonDisabled,
        attackId,
        customerId,
        onClickToAttackTimeline,
        hideViewFullTimelineButton = false,
    } = props;

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const DialogTitle = withStyles(styles)((props) => {
        const { children, classes, onClose, ...other } = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });

    return (
        <div>
            <Tooltip title={isTimelineButtonDisabled ? "Quick-view is not available" : "Quick-view the attack timeline."}>
                <span>
                    <Button
                        variant="outlined"
                        // size={"small"}
                        color="default"
                        className={!isTimelineButtonDisabled ? "text-electric-blue" : ""}
                        onClick={handleClickOpen}
                        disabled={isTimelineButtonDisabled}
                    >
                    <BBIconQuickViewMagnifying />
                </Button>
                </span>

            </Tooltip>
            <Dialog
                fullWidth={true}
                maxWidth={"xl"}
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    Attack Timeline Quick View
                    {!isTimelineButtonDisabled && !hideViewFullTimelineButton &&
                        <div className={"px-2 mr-5 float-right"}>
                            <Tooltip title={"View full attack details in the Attack Inspector."}>
                                <Button
                                    variant="outlined"
                                    // size={"small"}
                                    color="default"
                                    className={!isTimelineButtonDisabled ? "text-electric-blue" : ""}
                                    onClick={onClickToAttackTimeline}
                                    disabled={isTimelineButtonDisabled}
                                >
                                    <BBIconAnalysisNetwork />
                                </Button>
                            </Tooltip>
                        </div>
                    }

                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        This timeline contains all events for this attack.  Expand each event to see more details.
                    </DialogContentText>
                    {/*<TextField*/}
                    {/*    autoFocus*/}
                    {/*    margin="dense"*/}
                    {/*    id="name"*/}
                    {/*    label="Email Address"*/}
                    {/*    type="email"*/}
                    {/*    fullWidth*/}
                    {/*/>*/}
                    <AttackInspector
                        defaultAttackId = {attackId}
                        customerId = {customerId}
                        showTimelineOnly
                    />
                </DialogContent>
                <DialogActions>
                    {/*<Button onClick={handleClose} color="primary">*/}
                    {/*    Cancel*/}
                    {/*</Button>*/}
                    <small className={" mx-5"}>Attack ID: {attackId}</small>
                    <Button onClick={handleClose} color="primary">
                        Done
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default FormDialog;
